import { render, staticRenderFns } from "./schoolHot.vue?vue&type=template&id=738fb534&scoped=true&"
import script from "./schoolHot.vue?vue&type=script&lang=js&"
export * from "./schoolHot.vue?vue&type=script&lang=js&"
import style0 from "./schoolHot.vue?vue&type=style&index=0&id=738fb534&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738fb534",
  null
  
)

export default component.exports